var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49903 15.75H5.45703L13.52 7.68799L12.561 6.72899L4.49903 14.792V15.75ZM15.457 7.08299L13.187 4.79199L13.707 4.27099C13.985 3.97899 14.3184 3.83299 14.707 3.83299C15.0964 3.83299 15.4297 3.97899 15.707 4.27099L16.332 4.89599C16.5127 5.06266 16.596 5.28499 16.582 5.56299C16.568 5.84033 16.4777 6.06233 16.311 6.22899L15.457 7.08299ZM14.832 7.68799L5.85303 16.667H3.58203V14.396L12.561 5.41699L14.832 7.68799ZM13.041 7.20799L12.561 6.72899L13.52 7.68799L13.041 7.20799Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit_2.d073777ae0b03e849306961599540c20.svg";
export { ForwardRef as ReactComponent };